const hideDelay = 250;
export let hideTimeout: NodeJS.Timeout;

export const accountMenu = document.getElementById('account-menu-container');
if (accountMenu)
{
    accountMenu.addEventListener('mouseenter', onAccountMenuMouseEnter);
    accountMenu.addEventListener('mouseleave', onAccountMenuMouseLeave);
}

export function onAccountMenuMouseEnter()
{
    clearTimeout(hideTimeout);
    showAccountMenu();
}

export function onAccountMenuMouseLeave()
{
    hideTimeout = setTimeout(hideAccountMenu, hideDelay);
}

export function showAccountMenu()
{
    accountMenu.classList.add('active');
}

export function hideAccountMenu()
{
    accountMenu.classList.remove('active');
}
